import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Footer from "components/Footer";
import Header from "components/Header";
import MainTitle from "components/MainTitle";
import QuickDonate from "components/QuickDonate/QuickDonate";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import { RootState } from "redux/rootReducer";
import { videosActions } from "redux/actions/VideosActions/videosActions";
import { playButton } from "assets/icons/index";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import { Spin } from "antd";

const Videos = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  useEffect(() => {
    dispatch(videosActions("video"));
  }, [dispatch]);

  const { videosLoading, videos } = useSelector(
    (state: RootState) => state.videosReducer
  );

  const [playVideos, setPlayVideos] = useState<boolean[]>(
    new Array(videos?.length).fill(false)
  );

  const handlePlayVideos = (i: number) => {
    setPlayVideos((prev) => {
      const newState = [...prev];
      newState[i] = !newState[i];
      return newState;
    });
  };

  return (
    <>
      <Header />
      <main className="relative">
        <QuickDonate />
        {quickDonateStatus && <QuickDonatePopUp />}
        <MainTitle title={t("Videos")} />

        {/* videos section  */}
        <Spin spinning={videosLoading}>
          <section className="my-[100px]">
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="mainContainer w-full px-[60px] lg:px-0 min-h-[300px] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-8"
            >
              {videos?.map((video: any, i: number) => {
                return (
                  <div
                    key={i}
                    data-aos="fade-up"
                    data-aos-duration="900"
                    className="relative w-full flex flex-col items-center justify-center"
                  >
                    <div
                      // ref={(el) => (playerContainerRefs.current[i] = el)}
                      className="relative w-full max-h-[200px] min-h-[200px] rounded-[20px] youtube-video"
                    >
                      <ReactPlayer
                        url={video?.file_name}
                        width="100%"
                        height="100%"
                        controls={playVideos[i]}
                        playing={playVideos[i]}
                        playIcon={playButton}
                        // onPlay={() => handleFullscreen(i)}
                      />

                      {!playVideos[i] && (
                        <div
                          onClick={() => handlePlayVideos(i)}
                          className="absolute top-0 left-0 w-full h-full bg-black/25 flex flex-col items-center justify-center rounded-[20px] hover:bg-first_color/85 duration-700 group"
                        >
                          <div className="w-[40px] h-[40px] cursor-pointer bg-white rounded-full flex items-center justify-center">
                            <img
                              className="max-w-[20px]"
                              src={playButton}
                              alt=""
                            />
                          </div>

                          {/* video title  */}
                          <p
                            className={`font-${
                              i18n.language === "en" ? "Poppins " : "Almarai "
                            } font-[600] text-white text-[18px] max-w-[300px] overflow-hidden text-ellipsis hidden group-hover:block duration-700`}
                          >
                            {i18n.language === "en"
                              ? video?.title_en
                              : video?.title_ar}
                          </p>

                          {/* date  */}
                          <p
                            className={`font-${
                              i18n.language === "en" ? "Poppins " : "Almarai "
                            } font-[600] text-white text-[14px] max-w-[300px] overflow-hidden text-ellipsis hidden group-hover:block duration-700`}
                          >
                            {t("Date")}: {video?.created_on.slice(0, 10)}
                          </p>
                        </div>
                      )}
                    </div>

                    {/* title and description */}
                    <div className="mt-[5px] w-full flex flex-col gap-1">
                      <p
                        className={`font-${
                          i18n.language === "en" ? "Poppins " : "Almarai "
                        } font-[600] text-first_color text-[14px] max-w-[300px] overflow-hidden text-ellipsis hidden group-hover:block duration-700`}
                      >
                        {t("Date")}: {video?.created_on.slice(0, 10)}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        </Spin>
      </main>
      <Footer />
    </>
  );
};

export default Videos;
